import { render, staticRenderFns } from "./PDFThumbnail.vue?vue&type=template&id=a2a76e86&scoped=true"
import script from "./PDFThumbnail.vue?vue&type=script&lang=js"
export * from "./PDFThumbnail.vue?vue&type=script&lang=js"
import style0 from "./PDFThumbnail.vue?vue&type=style&index=0&id=a2a76e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a76e86",
  null
  
)

export default component.exports